export default __webpack_public_path__ + "static/media/exploded-view_sprite.5ab475a0.png";